<!-- @format -->
<template>
    <div class="form-from-template-widget">
        <loading-card :is-loading="isLoading" />
        <div class="widget-header">
            <h3>{{ title }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget()">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <form-settings-step
                :account-id="accountId"
                :client-id="clientId"
                :email-text-options="emailTextOptions"
                :form-options="formOptions"
                :is-loading="isLoading"
                :form-config="formConfig"
            />
        </div>
        <div class="widget-footer">
            <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            <app-button :disabled="!isFormValid" @click="saveForm">
                Next Step
                <span class="fa fa-arrow-right"></span>
            </app-button>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';
import { FormService } from '@/scripts/services/form/form-service';

const FormSettingsStep = () =>
    import('@/components/sliding-widgets/form-widget/form-settings-step');
const LoadingCard = () => import('@/components/common/loading-card');
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

export default {
    name: 'form-from-template-widget',

    components: {
        'loading-card': LoadingCard,
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'form-settings-step': FormSettingsStep,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,

            title: 'Create Form Template',

            formConfig: {
                parentFormId: null,
                name: '',
                title: '',
                description: '',
                categories: [],
                action: { id: 1, name: 'Display Text' },
                actionMessage: 'Thank you for your submission!',
                actionRedirect: '',

                emails: [
                    {
                        id: this.$helpers.createId('email'),
                        name: '',
                    },
                ],

                emailSubject: '',
                isPlainTextNotification: false,
                formSubmissionLists: [],
                configuration: '',
            },

            formOptions: [
                { id: 1, name: 'Display Text' },
                { id: 2, name: 'Redirect' },
            ],

            emailTextOptions: [
                { id: 2, name: 'No', selected: true },
                { id: 1, name: 'Yes', selected: false },
            ],
        };
    },

    computed: {
        accountId() {
            return this.widget.accountId;
        },

        clientId() {
            return this.widget.clientId;
        },

        formId() {
            return this.widget.formId;
        },

        isFormValid() {
            return this.formConfig.name.length > 0;
        },
    },

    created() {
        this.getFormData();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getFormData() {
            this.isLoading = true;

            const requestConfig = { expand: 'ListForms($expand=List)' };

            FormService.get(this.formId, requestConfig)
                .then(({ data: { value } }) => {
                    const [item] = value;

                    this.formConfig = {
                        ...this.formConfig,
                        name: item.Name,
                        title: item.Title,
                        description: item.Description,
                        configuration: item.Configuration,
                        parentFormId: item.Id,
                    };
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to get the form data', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getListIds(lists) {
            return lists.map((list) => {
                return list.id;
            });
        },

        saveForm() {
            this.isLoading = true;
            let payload = {
                Name: this.formConfig.name,
                Title: this.formConfig.title,
                Description: this.formConfig.description,
                Configuration: this.formConfig.configuration,
                ParentFormId: this.formConfig.parentFormId,
                AccountId: this.accountId,
                Categories: this.formConfig.categories,
                Action: this.formConfig.action.name,
                Message: this.formConfig.actionMessage,
                SendAsPlainText: this.formConfig.isPlainTextNotification,
                Emails: this.emails,
                EmailSubject: this.formConfig.emailSubject,
                Redirect: this.formConfig.actionRedirect,
                ListIds: this.getListIds(this.formConfig.formSubmissionLists),
            };

            FormService.post(payload)
                .then(({ data: id }) => {
                    this.$helpers.showSuccessNotification('Form created successfully');
                    this.closeWidget();
                    this.$router.push(`Forms/${id}/Design`);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred when creating form', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style>
.form-from-template-widget .widget-footer .transparent-btn {
    background: transparent;
    border: none;
    color: #877d88;
}

.form-from-template-widget .widget-footer .transparent-btn:hover {
    background: #e1e0e5;
}

.form-from-template-widget .widget-footer .app-button span.fa {
    margin-left: 10px;
}
</style>
